import { initializeApp, getApps } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase config with fallbacks for environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDJoXp6OdCmzF7_O_dy8Xe25FPGPwubUJ8',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'ai-revenue-1a4cc.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'ai-revenue-1a4cc',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'ai-revenue-1a4cc.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '904890050710',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:904890050710:web:77ee1788f7b8e180d23ab7',
};

let app;

if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Set persistence to LOCAL (persists across browser sessions)
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.warn('Failed to set auth persistence:', error);
});

// Export serverTimestamp for easy access
export { serverTimestamp } from 'firebase/firestore';
